/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TAddFlatTourBookingModel,
  IAddFlatTourBookingRequest,
  IMappers,
  IAddFlatTourBookingResponse,
  IAddFlatTourBookingResponseError,
  TAddFlatTourBookingResponse,
} from './types';

const defaultConfig: TAddFlatTourBookingModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'newbuilding-calltracking',
  pathApi: '/v1/add-flat-tour-booking',
  hostType: 'api',
} as TAddFlatTourBookingModel;

function createAddFlatTourBookingModel(parameters: IAddFlatTourBookingRequest): TAddFlatTourBookingModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddFlatTourBookingOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IAddFlatTourBookingRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchAddFlatTourBooking<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IAddFlatTourBookingOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TAddFlatTourBookingResponse
> {
  const { response, statusCode } = await httpApi.fetch(createAddFlatTourBookingModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddFlatTourBookingResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IAddFlatTourBookingResponseError);
    }
  }

  return { response, statusCode } as TAddFlatTourBookingResponse;
}

export { defaultConfig, createAddFlatTourBookingModel, fetchAddFlatTourBooking };
